import { uniq } from 'lodash-es'
import { isNonEmptyString } from '#app/lib/boolean_tests'
import type { EntityImagesByLang } from '#server/controllers/entities/lib/get_entities_images'
import type { Descriptions, Labels, SingleValueTermsWithInferredValues } from '#server/types/entity'
import type { EmptyObject } from 'type-fest'
import type { WikimediaLanguageCode } from 'wikibase-sdk'

export interface BestLangValue {
  lang: WikimediaLanguageCode
  value: string
}

type GetBestLangValueInput = Labels | Descriptions | SingleValueTermsWithInferredValues | EntityImagesByLang

export function getBestLangValue (lang: WikimediaLanguageCode, originalLang: WikimediaLanguageCode, data?: GetBestLangValueInput): BestLangValue | EmptyObject {
  if (!data) return {}

  const order = getLangPriorityOrder(lang, originalLang, data)

  while (order.length > 0) {
    const nextLang = order.shift()
    let value = data[nextLang]
    if (value instanceof Array) {
      value = value[0]
    }
    if (isNonEmptyString(value)) {
      return { value, lang: nextLang } as BestLangValue
    }
  }

  return {}
}

function getLangPriorityOrder (lang: WikimediaLanguageCode, originalLang: WikimediaLanguageCode, data: GetBestLangValueInput) {
  const order = [ lang, 'mul' ]
  if (originalLang != null) order.push(originalLang)
  order.push('en')
  const availableLangs = Object.keys(data)
  return uniq(order.concat(availableLangs))
}
